export type SwitchStatus =
  | 'notPressedBoth'
  | 'pressedFirst'
  | 'pressedSecond'
  | 'pressedBoth'
  | 'unknown'

// platform stand_data.dart isStandSwitchPressed / spot aesStandData の実装を移設。
// 操作方向のスイッチのみ「押下」とみなす（rental=first/両・return=second/両・unknown=false）。
export function isStandSwitchPressed(params: {
  when: 'rental' | 'return'
  switchStatus: SwitchStatus
}): boolean {
  const { when, switchStatus } = params
  if (when === 'rental') {
    return switchStatus === 'pressedFirst' || switchStatus === 'pressedBoth'
  }
  if (when === 'return') {
    return switchStatus === 'pressedSecond' || switchStatus === 'pressedBoth'
  }
  return false
}
